import React from "react";
import CourseTemplate from "../../components/CourseTemplate";

const BTechAgriculturalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Tech. Agricultural Engineering",
    shortName: "B.Tech. Agricultural",
    duration: "4 years",
    description: "Engineering program focused on applying technology and engineering principles to agricultural production and food processing",
    overview: "Bachelor of Technology in Agricultural Engineering (B.Tech. Agricultural) is a 4-year undergraduate program that combines engineering principles with agricultural sciences to develop technological solutions for farming, irrigation, food processing, and rural development. This course prepares students to modernize agriculture through mechanization, automation, and sustainable practices.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics/Biology",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET/Agriculture entrance exams",
      "Interest in agriculture and technology"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Agricultural Sciences",
          "Computer Programming"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Fluid Mechanics",
          "Thermodynamics",
          "Soil and Water Engineering",
          "Farm Machinery",
          "Agricultural Economics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Irrigation Engineering",
          "Farm Power and Machinery",
          "Food Process Engineering",
          "Agricultural Structures",
          "Renewable Energy in Agriculture",
          "Precision Agriculture"
        ]
      },
      {
        year: 4,
        subjects: [
          "Post-Harvest Technology",
          "Agricultural Automation",
          "Watershed Management",
          "Agribusiness Management",
          "Project Work",
          "Rural Development"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Agricultural Engineer",
        "Irrigation Engineer",
        "Farm Machinery Engineer",
        "Food Processing Engineer",
        "Agricultural Consultant",
        "Project Manager (Rural Development)",
        "Research Scientist",
        "Agricultural Equipment Designer"
      ],
      industries: [
        "Agricultural Equipment Manufacturers",
        "Food Processing Companies",
        "Irrigation Companies",
        "Government Agricultural Departments",
        "Rural Development Organizations",
        "Consulting Firms",
        "Research Institutions",
        "International Development Agencies"
      ],
      averageSalary: "₹3.5-7 LPA (Fresher), ₹10-20 LPA (Experienced)",
      topRecruiters: [
        "Mahindra & Mahindra",
        "TAFE, John Deere",
        "Jain Irrigation",
        "ITC, Nestle",
        "NABARD, FCI",
        "ICAR Research Institutes"
      ]
    },
    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for agricultural universities)",
      "ICAR AIEEA (All India entrance)",
      "State agricultural entrance exams",
      "Management quota admissions"
    ],
    topColleges: [
      {
        name: "Agricultural Engineering College, TNAU",
        location: "Coimbatore",
        fees: "₹1,50,000",
        ranking: "ICAR A+ Grade"
      },
      {
        name: "Tamil Nadu Agricultural University",
        location: "Coimbatore",
        fees: "₹1,20,000",
        ranking: "ICAR A+ Grade"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹2,00,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "KLN College of Engineering",
        location: "Sivaganga",
        fees: "₹2,50,000",
        ranking: "NAAC A Grade"
      }
    ],
    agriculturalColleges: [
      { slNo: 1, name: "Agricultural College and Research Institute", location: "Coimbatore" },
      { slNo: 2, name: "Agricultural College and Research Institute", location: "Madurai" },
      { slNo: 3, name: "V.O. Chidambaranar Agricultural College and Research Institute", location: "Killikulam, Tuticorin" },
      { slNo: 4, name: "Anbil Dharmalingam Agricultural College and Research Institute", location: "Navalur Kuttappattu, Tiruchirappalli" },
      { slNo: 5, name: "Agricultural College and Research Institute", location: "Vazhavachanur, Tiruvannamalai" },
      { slNo: 6, name: "Agricultural College and Research Institute", location: "Kudumiyanmalai, Pudukkottai" },
      { slNo: 7, name: "Dr. M. S. Swaminathan Agricultural College and Research Institute", location: "Eachangkottai, Thanjavur" },
      { slNo: 8, name: "Horticultural College and Research Institute", location: "Coimbatore" },
      { slNo: 9, name: "Horticultural College and Research Institute", location: "Periyakulam, Theni" },
      { slNo: 10, name: "Horticultural College and Research Institute for Women", location: "Navalur Kuttappattu, Tiruchirappalli" },
      { slNo: 11, name: "Agricultural Engineering College and Research Institute", location: "Coimbatore" },
      { slNo: 12, name: "Agricultural Engineering College and Research Institute", location: "Kumulur, Tiruchirappalli" },
      { slNo: 13, name: "Forest College and Research Institute", location: "Mettupalayam" },
      { slNo: 14, name: "Community Science College and Research Institute", location: "Madurai" },
      { slNo: 15, name: "Horticultural College and Research Institute", location: "Paiyur, Krishnagiri" },
      { slNo: 16, name: "Agricultural College and Research Institute", location: "Chettinad, Sivagangai" },
      { slNo: 17, name: "Agricultural College and Research Institute", location: "Keezh Velur, Nagapattinam" },
      { slNo: 18, name: "Agricultural College and Research Institute", location: "Karur" }
    ],
    skills: [
      "Farm Machinery Design",
      "Irrigation System Design",
      "Soil and Water Conservation",
      "Food Processing Technology",
      "CAD/CAM Applications",
      "Precision Agriculture",
      "Project Management",
      "Rural Development",
      "Sustainable Agriculture",
      "Agricultural Economics"
    ],
    futureScope: "Excellent opportunities with focus on sustainable agriculture, precision farming, agtech startups, and government initiatives for rural development and food security.",
    faqs: [
      {
        question: "Is Agricultural Engineering only about farming?",
        answer: "No, it covers farm machinery, irrigation, food processing, rural infrastructure, and agribusiness management with diverse career opportunities."
      },
      {
        question: "Are there good placement opportunities?",
        answer: "Yes, in agricultural equipment companies, food processing industries, government sectors, and emerging agtech startups."
      },
      {
        question: "Can I work in urban areas?",
        answer: "Yes, many opportunities in manufacturing companies, food processing units, consulting firms, and research institutions in urban areas."
      },
      {
        question: "What are the higher study options?",
        answer: "M.Tech in Agricultural Engineering, MBA in Agribusiness, or specialized courses in precision agriculture and food technology."
      }
    ]
  };
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BTechAgriculturalCoursePage;
